module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('van-tabs', {
    staticClass: "tab-nav",
    attrs: {
      "sticky": ""
    },
    on: {
      "click": _vm.onStatusChange
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('van-tab', {
    attrs: {
      "title": "全部"
    }
  }), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "待付款"
    }
  }), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "待拼团"
    }
  }), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "待发货"
    }
  }), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "待收货"
    }
  }), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "售后中"
    }
  }), _vm._v(" "), _c('van-pull-refresh', {
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, _vm._l((_vm.list), function(order, index) {
    return _c('div', {
      staticClass: "row-list",
      on: {
        "click": function($event) {
          return _vm.goOrderDetail(order.id, order.type, order)
        }
      }
    }, [_c('div', {
      staticClass: "justify-space-flex row-title"
    }, [_c('div', {
      staticClass: "title-left flex-start gray"
    }, [_c('img', {
      staticClass: "row-title-img",
      attrs: {
        "src": order.business_pic_url,
        "alt": ""
      }
    }), _vm._v("\n              " + _vm._s(order.business_name) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "title-right"
    }, [_vm._v(_vm._s(order.status_buttons.name))])]), _vm._v(" "), _vm._l((order.items), function(goods, index) {
      return _c('div', {
        staticClass: "justify-space-flex row-goods"
      }, [_c('div', {
        staticClass: "row-left flex-start"
      }, [_c('img', {
        staticClass: "row-left-img",
        attrs: {
          "src": goods.pic_url,
          "alt": ""
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "goods-detail"
      }, [_c('div', {
        staticClass: "goods-name"
      }, [_vm._v(_vm._s(goods.title))]), _vm._v(" "), _c('div', {
        staticClass: "goods-weight gray-light"
      }, [_vm._v(_vm._s(goods.sku.sku_formart))])])]), _vm._v(" "), _c('div', {
        staticClass: "row-right"
      }, [_c('div', {
        staticClass: "goods-price"
      }, [_c('span', [_vm._v("¥")]), _vm._v("\n                " + _vm._s(goods.goods_price_base) + "\n              ")]), _vm._v(" "), _c('div', {
        staticClass: "goods-num gray-light"
      }, [_vm._v("数量 " + _vm._s(goods.count))])])])
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding": "0 0.3rem"
      }
    }, [_vm._v("收款省市:" + _vm._s(order.collection_p_c))]), _vm._v(" "), (order.use_time_range) ? _c('van-notice-bar', {
      attrs: {
        "text": '可用时限' + order.use_time_range[0] + '  ~  ' + order.use_time_range[1]
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "row-btn"
    }, _vm._l((order.status_buttons.buttons), function(btn, index) {
      return _c('div', {
        class: btn.class + '-btn'
      }, [_vm._v(_vm._s(btn.name))])
    }), 0)], 2)
  }), 0)], 1)], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57bf6794","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/order/WyhOrderList.vue
// module id = 2410
// module chunks = 0